import getRegionByCountryCode from './getRegionByCountryCode';
import getSectorByItemGroupCode from './getSectorByItemGroupCode';
import { BannerMessages, RegionSector, RegionSectorToMessages } from './types';

export const regionSectorToMessages: RegionSectorToMessages = {
  [RegionSector.EuropeITOffice]: [
    {
      number: '7.1 million',
      message:
        '...a leading laptop brand in GB could generate this much more in annual Laptop sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '19% Brand Enthusiasts',
      message:
        '...make up the biggest proportion of the European IT-Office market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.EuropeConsumerElectronics]: [
    {
      number: '12 million',
      message:
        '...a leading TV brand in GB could generate this much more in annual TV sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '16% Store Seekers',
      message:
        '...make up the biggest proportion of the European TV market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.EuropeSDA]: [
    {
      number: '3.6 million',
      message:
        '...a leading Vacuum Cleaner brand in DE could generate this much more in annual Vacuum Cleaner sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '28% Pragmatics',
      message:
        '...make up the biggest proportion of the European Vacuum Cleaner market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.EuropeMDA]: [
    {
      number: '4.8 million',
      message:
        '...a leading Washing Machine brand in DE could generate this much more in annual Washing Machines sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '22% Store Seekers',
      message:
        '...make up the biggest proportion of the European MDA market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.EuropeMobilePhone]: [
    {
      number: '12 million',
      message:
        '...a leading Mobile Phone brand in DE could generate this much more in annual Mobile Phone sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '24% High Spec Premiums',
      message:
        '...make up the biggest proportion of the European Mobile Phone market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.BrazilITOffice]: [
    {
      number: '8.6 million',
      message:
        '...a leading Laptop brand in BR could generate this much more in annual Laptop sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '29% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Brazilian IT-Office market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.BrazilConsumerElectronics]: [
    {
      number: '8.2 million',
      message:
        '...a leading TV brand in BR could generate this much more in annual TV sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '24% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Brazilian TV market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.BrazilMDA]: [
    {
      number: '9.1 million',
      message:
        '...a leading Washing Machine brand in BR could generate this much more in annual Washing Machine sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '30% Brand Enthusiasts',
      message:
        '...make up the biggest proportion of the Brazilian Washing Machine market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.BrazilSDA]: [
    {
      number: '1 million',
      message:
        '...a leading Vacuum Cleaner brand in BR could generate this much more in annual Vacuum Cleaner sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '30% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Brazilian Vacuum Cleaner market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.BrazilMobilePhone]: [
    {
      number: '18 million',
      message:
        '...a leading Mobile Phone brand in BR could generate this much more in annual Mobile Phone sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '25% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Brazilian Mobile Phone market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.JapanITOffice]: [
    {
      number: '4.9 million',
      message:
        '...a leading Laptop brand in JP could generate this much more in annual Laptop sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '19% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Japanese IT-Office market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.JapanMobilePhone]: [
    {
      number: '16 million',
      message:
        '...a leading Mobile Phone brand in JP could generate this much more in annual Mobile Phone sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '22% Store Seekers',
      message:
        '...make up the biggest proportion of the Japanese Mobile Phone market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.JapanConsumerElectronics]: [
    {
      number: '10 million',
      message:
        '...a leading TV brand in JP could generate this much more in annual TV sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '22% High Spec Premiums',
      message:
        '...make up one of the biggest proportions of the Japanese TV market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.JapanSDA]: [
    {
      number: '4.5 million',
      message:
        '...a leading Vacuum Cleaner brand in JP could generate this much more in annual Vacuum Cleaner sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '27% Store Seekers',
      message:
        '...make up the biggest proportion of the Japanese Vacuum Cleaner market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.JapanMDA]: [
    {
      number: '7.9 million',
      message:
        '...a leading Washing Machine brand in JP could generate this much more in annual Washing Machine sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '36% Store Seekers',
      message:
        '...make up the biggest proportion of the Japanese Washing Machine market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.TurkeyConsumerElectronics]: [
    {
      number: '3.8 million',
      message:
        '...a leading TV brand in TR could generate this much more in annual TV sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '30% Store Seekers',
      message:
        '...make up the biggest proportion of the Turkish TV market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.TurkeySDA]: [
    {
      number: '4.3 million',
      message:
        '...a leading Vacuum Cleaner brand in TR could generate this much more in annual Vacuum Cleaner sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '34% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Turkish Vacuum Cleaner market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.TurkeyITOffice]: [
    {
      number: '3.5 million',
      message:
        '...a leading Laptop brand in TR could generate this much more in annual Laptop sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '36% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Turkish IT-Office market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.TurkeyMDA]: [
    {
      number: '5.2 million',
      message:
        '...a leading Washing Machine brand in TR could generate this much more in annual Washing Machine sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '25% Store Seekers',
      message:
        '...make up the biggest proportion of the Turkish Washing Machine market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.IndiaMDA]: [
    {
      number: '11 million',
      message:
        '...a leading Washing Machine brand in IN could generate this much more in annual Washing Machine sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '25% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Indian Washing Machine market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.IndiaITOffice]: [
    {
      number: '15 million',
      message:
        '...a leading Laptop brand in IN could generate this much more in annual Laptop sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '37% Digitally Receptives',
      message:
        '...make up the biggest proportion of the Indian IT-Office market but some leading brands struggle to convert them',
    },
  ],
  [RegionSector.IndiaConsumerElectronics]: [
    {
      number: '21 million',
      message:
        '...a leading TV brand in IN could generate this much more in annual TV sales by reducing their lost shoppers by just 1%',
    },
    {
      number: '23% Store Seekers',
      message:
        '...make up the biggest proportion of the Indian TV market but some leading brands struggle to convert them',
    },
  ],
};

export const getBannerMessages = (market?: string, bannerIndex?: number): BannerMessages | undefined => {
  const [itemGroupCode, countryCode] = (market ?? '').split('/');
  if (!itemGroupCode || !countryCode) {
    return undefined;
  }

  const region = getRegionByCountryCode(countryCode);
  const sector = getSectorByItemGroupCode(itemGroupCode);
  if (!region || !sector) {
    return undefined;
  }

  const messages = regionSectorToMessages[`${region}${sector}`];
  if (!messages) {
    return undefined;
  }

  return messages[bannerIndex ?? 0];
};
